<template>
  <div class="big_box">
    <report-table-children
      :api-config="apiConfig"
      :date-field="'billDateRange'"
      data-key="data"
      :show-pagination="true"
      report-key="PurifyDtlRpt"
    />
  </div>
</template>

<script>
import { apiPurifyDtlRpt, apiPurifyDtlRptPull, apiPurifyDtlRptExport } from '@/request/api';

export default {
  name: 'PurifyDtlRpt',
  data() {
    return {
      apiConfig: {
        pull: apiPurifyDtlRptPull,
        getData: apiPurifyDtlRpt,
        exportData: apiPurifyDtlRptExport 
      }
    };
  }
};
</script>

<style  lang="scss" scoped>
</style>
